module.exports = __webpack_public_path__ + "img/3.01.9b1fb286.jpg";